
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M84.41 10H15.59A5.6 5.6 0 0010 15.59v68.82A5.6 5.6 0 0015.59 90h68.82A5.6 5.6 0 0090 84.41V15.59A5.6 5.6 0 0084.41 10zm2.07 51.33l-9.35-9.35a5.601 5.601 0 00-7.91 0L58.41 62.8 35.7 40.09a5.545 5.545 0 00-3.95-1.64c-1.49 0-2.9.58-3.95 1.64L13.52 54.36V15.59c0-1.14.93-2.07 2.07-2.07h68.82c1.14 0 2.07.93 2.07 2.07v45.74z"}}),_c('circle',{attrs:{"cx":"60.26","cy":"40.26","r":"9.44"}})])
          )
        }
      }
    